import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Conexao from '../../Config/conexao';
import Navbar from '../../SGI/EPIS/NavBarSSMT';
import moment from 'moment';


export default function PlanoDeAcoesSSMT(){


    const [listaAcoes,setListaAcoes] =useState([]); 
    const [listaAcoesFiltrada,setListaAcoesFiltrada] =useState([]);
    const dataAtual = moment();
    const [dataExecutada,setDataExecutada] = useState();
    const [filtro, setFiltro] = useState(false);
    const [projeto, setProjeto] = useState('');
    const [dataDoCheckList, setDataDoCheckList] = useState('');
    const [checkList, setCheckList] = useState('');
    const [usuario, setUsuario] = useState('');

    function carregaUser(){setUsuario (localStorage.usuario) }; 
    useEffect(() => { carregaUser() },[]);  


    async function getAcoes() {  
        const res = await axios.get(Conexao.api + 'ListaAcoesCheckListWEB.php' );                
        if (res.data.success === false) { 
        } else {
        setListaAcoes(res.data.result); 
        }   
      };

    
      useEffect(() => {
        getAcoes();
      });



      const SalvarAcoes = async (id) => {
        const dataExecucao = moment(dataExecutada).format("DD-MM-YYYY")      
        const obj = { id,  dataExecucao, usuario  };
        const res = await axios.post(Conexao.api + 'UpDateAcoesConcluidasCheckWEB.php', obj);
        if (res.data.success === true) {
         alert("Ação concluida!")
        }            
    };


    function Limpar(){
        setDataExecutada('')
    };

    function Limpar2(){
        setCheckList('');
        setDataDoCheckList('');
        setProjeto('');
        setListaAcoesFiltrada(['']);
    };

    function AbrirFiltro(){
        setFiltro(!filtro) 
        Limpar2();
      };


      async function getAcoesFiltradas() {  
         const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
        const res = await axios.get(Conexao.api + 'ListaAcoesFiltradaSSMTWEB.php?checklist='+ checkList 
        +  '&projeto=' + projeto +  '&dataCheckList=' + dataCheckList  ); 
      
        if (res.data.success === false) { 
            alert('Nusca não encontrada!')  
            Limpar2() 
        } else {
            
            setListaAcoesFiltrada(res.data.result);
        }   
      };


      async function getAcoesFiltradas1() {  
        const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
       const res = await axios.get(Conexao.api + 'ListaAcoesFiltradaSSMT1WEB.php?checklist='+ checkList 
       +  '&projeto=' + projeto +  '&dataCheckList=' + dataCheckList  ); 
       if (res.data.success === false) { 
           alert('Nusca não encontrada!')
           Limpar2()   
       } else {     
           setListaAcoesFiltrada(res.data.result);
       }   
     };


     async function getAcoesFiltradas2() {  
       const res = await axios.get(Conexao.api + 'ListaAcoesFiltradaSSMT2WEB.php?checklist='+ checkList 
       +  '&projeto=' + projeto   );   
       if (res.data.success === false) { 
           alert('Nusca não encontrada!')  
           Limpar2() 
       } else {      
           setListaAcoesFiltrada(res.data.result);
       }   
     };


     async function getAcoesFiltradas3() {  
        const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
       const res = await axios.get(Conexao.api + 'ListaAcoesFiltradaSSMT3WEB.php?checklist='+ checkList 
       +    '&dataCheckList=' + dataCheckList  ); 
       if (res.data.success === false) { 
           alert('Nusca não encontrada!')   
           Limpar2()
       } else {       
           setListaAcoesFiltrada(res.data.result);
       }   
     };


     function Buscas(){
            if(dataDoCheckList !== '' && checkList !== '' && projeto !== ''){getAcoesFiltradas1()}
            else if (dataDoCheckList === '' && checkList !== '' && projeto !== ''){getAcoesFiltradas2()}
            else if(dataDoCheckList !== '' && checkList !== '' && projeto === ''){getAcoesFiltradas3()}
            else{getAcoesFiltradas()}
     };


  




    return( <body>

        <Navbar/>

        <div className='titulolaboratorio container-fluid '>
             <h1 className='texttitulo'>PLANO DE AÇÕES</h1>
        </div> 



        {filtro===false?(  <button onClick={()=>AbrirFiltro()} class="btnlogin ">Filtro</button>)
        :(  <button onClick={()=>AbrirFiltro()} class="btnlogin ">Fechar filtro</button>)}


        {filtro !==false?( <div className='container align-items-center justify-content-center'><br/>


                <div className='d-flex container col-6 mt-2 text-start justify-content-center align-items-center'>
                    <div className='col-3'></div>
                    <div className='col-2'>
                        <h6 >Check-List:</h6>
                    </div>

                    <div className='col-5'>
                        <select onChange={(e)=> setCheckList(e.target.value)} value={checkList} class="borda form-select text-center ms-2">
                            <option value={''}>Selecione</option>
                            <option value={'1'}>Check-list caminhão prancha</option>
                            <option value={'2'}>Check-list alojamento</option>
                            <option value={'3'}>Check-list componentes e acessórios</option>
                            <option value={'4'}>Check-list diário de sonda</option>
                            <option value={'5'}>Check-list extintores</option>
                            <option value={'6'}>Check-list fadiga</option>
                            <option value={'7'}>Check-list ferramentas</option>
                            <option value={'8'}>Check-list fogareiro</option>
                            <option value={'9'}>Check-list inspeção de campo</option>
                            <option value={'10'}>Check-list kit ambiental</option>
                            <option value={'11'}>Check-list meio ambiente</option>
                            <option value={'12'}>Check-list praça de sondagem</option>
                            <option value={'13'}>Check-list pré-campo</option>
                            <option value={'14'}>Check-list veículos</option>
                            <option value={'15'}>Check-list caminhão pipa</option>
                            <option value={'16'}>Ocorrências de campo</option>
                            <option value={'17'}>Relatos de incidentes</option>
                        </select>
                    </div>
                    <div className='col-2'></div>                  
                </div>


                <div className='d-flex container col-6 mt-2 text-start justify-content-center align-items-center'>
                    <div className='col-3'></div>
                    <div className='col-2'>
                        <h6 >Projeto:</h6>
                    </div>

                    <div className='col-5'>
                        <input onChange={(e)=> setProjeto(e.target.value)} value={projeto} class="borda form-control text-center ms-2"></input>
                    </div>
                    <div className='col-2'></div>                  
                </div>


                <div className='d-flex container col-6 mt-2 text-start justify-content-center align-items-center'>
                    <div className='col-3'></div>
                    <div className='col-2'>
                        <h6 >Data:</h6>
                    </div>

                    <div className='col-5'>
                        <input onChange={(e)=> setDataDoCheckList(e.target.value)} value={dataDoCheckList} type='date' class="borda form-control text-center ms-2"></input>
                    </div>
                    <div className='col-2'></div>                  
                </div>


                <button onClick={()=>Buscas()} class="btnlogin mt-5">Buscar</button>


        </div>):null}

        <br/><br/><br/>

        <div className='d-flex container-fluid justify-content-center text-center cinzaclaro p-1'>
            <div className='col-2'>CheckList </div>
            <div className='col-1'>Projeto</div>
            <div className='col-1'>Data</div>
            <div className='col-1'>Número do item</div>
            <div className='col-2'>Ação tomada</div>
            <div className='col-1'>Prazo</div>
            <div className='col-1'>Data execução</div>
            <div className='col-1'>Responsável</div>
            <div className='col-1'>Status</div>
            <div className='col-1'>Executar</div>
        </div>

        
{filtro===false?( <div>
        {listaAcoes.map((a) => ( 
                      
            <div key={a.id}  >       
            { a.acao  && a.prazo   ?( <div className='d-flex container-fluid  colorInput p-1 borda'>               
                {a.checkList === "1"?(<div className='col-2 text-center'>Caminhão prancha </div>):null}
                {a.checkList === "2"?(<div className='col-2 text-center '>Alojamento </div>):null}
                {a.checkList === "3"?(<div className='col-2 text-center'>Componentes e acessórios </div>):null}
                {a.checkList === "4"?(<div className='col-2 text-center'>Diário de sonda </div>):null}
                {a.checkList === "5"?(<div className='col-2 text-center'>Extintores </div>):null}
                {a.checkList === "6"?(<div className='col-2 text-center'>Inspeção sobre fadíga </div>):null}
                {a.checkList === "7"?(<div className='col-2 text-center'>Ferramentas manuais </div>):null}
                {a.checkList === "8"?(<div className='col-2 text-center'>Fogareiro </div>):null}
                {a.checkList === "9"?(<div className='col-2 text-center'>Inspeção de campo </div>):null}
                {a.checkList === "10"?(<div className='col-2 text-center'>Kit ambiental </div>):null}
                {a.checkList === "11"?(<div className='col-2 text-center'>Inspeção de meio ambiente </div>):null}
                {a.checkList === "12"?(<div className='col-2 text-center'>Praça de sondagem </div>):null}
                {a.checkList === "13"?(<div className='col-2 text-center'>Pré-campo </div>):null}
                {a.checkList === "14"?(<div className='col-2 text-center'>Inspeção diária de veículos </div>):null}
                {a.checkList === "15"?(<div className='col-2 text-center'>Caminhão-pipa </div>):null}
                {a.checkList === "16"?(<div className='col-2 text-center'>Ocorrências de campo </div>):null}
                {a.checkList === "17"?(<div className='col-2 text-center'>Relato de incidente ambiental</div>):null}

            <div className='col-1  text-center'>{a.projeto}</div>
            <div className='col-1 text-center'>{a.dataCheckList}</div>
            <div className='col-1 text-center'>{a.numeroItem}</div>
            <div className='col-2 text-center'>{a.acao}</div>
            <div className='col-1 text-center'>{a.prazo}</div>
            <div className='col-1 text-center'>{a.dataExecucao}</div>
            <div className='col-1 text-center'>{a.usuario}</div>
            
    <div className='col-1 d-flex align-items-center justify-content-center'>
                { a.dataExecucao !== null?
                (
                    <div className='d-flex align-items-center'>              
                    <div style={{ width: '13px', height: '13px', backgroundColor: 'green', borderRadius: '50%', display: 'inline-block', marginLeft: '5px' }}></div>
                    <label className='ms-1' >Concluído</label>
                    </div> 
              )  :
              (
               a.dataExecucao === null && moment(dataAtual).isSameOrAfter(moment(a.prazo, 'DD-MM-YYYY'), 'day')?
              <div className='d-flex align-items-center'>              
                  <div style={{ width: '13px', height: '13px', backgroundColor: 'red', borderRadius: '50%', display: 'inline-block', marginLeft: '5px' }}></div>
                  <label className='ms-1'>Em atraso</label>
                  </div> 
              : 
              <div className='d-flex align-items-center'>              
              <div style={{ width: '13px', height: '13px', backgroundColor: 'darkorange', borderRadius: '50%', display: 'inline-block', marginLeft: '5px' }}></div>
              <label className='ms-1'>Aberto</label>
              </div> 
              )
              }               
        </div>                  
            <div className='col-1 justify-content-center text-center'>
            { a.dataExecucao === null  ?(
                <button data-bs-toggle="modal" data-bs-target={`#ModalAcoes-${a.id}`}  className="far fa-edit icone-acao green botaao "></button>
            )
            :
            (<button disabled  className="far fa-edit icone-acao green botaao"></button>)
            }
            </div>
               <div class="modal" id={`ModalAcoes-${a.id}`} tabindex="" aria-labelledby="ModalAcoesLabel" aria-hidden="true" >
                    <div class="modal-dialog modal-dialog-centered modal-md" >
                    <div class="modal-content">
                        <div class="modal-header">
                        <h1 class="modal-title fs-5" id="ModalAcoesLabel">Executar ação</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={()=>Limpar()}></button>
                        </div>

                        <div class="modal-body">
                        <div class="container text-center  ">
                    <div class="col  align-items-center justify-content-center p-2 ">
                        <div class="  align-items-center justify-content-center "> 
                            <div className='d-flex mt-2 align-items-center'>
                                <div className='col-5'>
                                    <label>Data: </label>
                                </div>
                                <div className='col-7'>
                                    <input onChange={(e)=>setDataExecutada(e.target.value)} value={dataExecutada} className='form-control text-center borda ms-2' type='date'></input>
                                </div>                          
                            </div>

                            <div className='d-flex mt-2 align-items-center'>
                                    <div className='col-5'>
                                        <label>Responsável: </label> 
                                    </div>
                                    <div className='col-7'>
                                          <input disabled={true} className='form-control text-center borda ms-2' onChange={(e)=>setUsuario(e.target.value)} value={usuario}></input>   
                                    </div>
                             </div>
                            
                        </div>
                        </div>
                    </div>
                        </div>
                        <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" onClick={()=>Limpar()} data-bs-dismiss="modal" >Fechar</button>             
                        <button type="button" class="btn btn-success" onClick={()=>SalvarAcoes(a.id) & Limpar()} data-bs-dismiss="modal" >Salvar</button>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            ):null}
         </div> ))  
         
         
         }   
</div>
         ):( <div>
            {listaAcoesFiltrada.map((a) => ( 
                          
                <div key={a.id}  >       
                { a.acao  && a.prazo   ?( <div className='d-flex container-fluid justify-content-center text-center colorInput p-1 borda'>               
                {a.checkList === "1"?(<div className='col-2 text-center'>Caminhão prancha </div>):null}
                {a.checkList === "2"?(<div className='col-2 text-center '>Alojamento </div>):null}
                {a.checkList === "3"?(<div className='col-2 text-center'>Componentes e acessórios </div>):null}
                {a.checkList === "4"?(<div className='col-2 text-center'>Diário de sonda </div>):null}
                {a.checkList === "5"?(<div className='col-2 text-center'>Extintores </div>):null}
                {a.checkList === "6"?(<div className='col-2 text-center'>Inspeção sobre fadíga </div>):null}
                {a.checkList === "7"?(<div className='col-2 text-center'>Ferramentas manuais </div>):null}
                {a.checkList === "8"?(<div className='col-2 text-center'>Fogareiro </div>):null}
                {a.checkList === "9"?(<div className='col-2 text-center'>Inspeção de campo </div>):null}
                {a.checkList === "10"?(<div className='col-2 text-center'>Kit ambiental </div>):null}
                {a.checkList === "11"?(<div className='col-2 text-center'>Inspeção de meio ambiente </div>):null}
                {a.checkList === "12"?(<div className='col-2 text-center'>Praça de sondagem </div>):null}
                {a.checkList === "13"?(<div className='col-2 text-center'>Pré-campo </div>):null}
                {a.checkList === "14"?(<div className='col-2 text-center'>Inspeção diária de veículos </div>):null}
                {a.checkList === "15"?(<div className='col-2 text-center'>Caminhão-pipa </div>):null}
                {a.checkList === "16"?(<div className='col-2 text-center'>Ocorrências de campo </div>):null}
                {a.checkList === "17"?(<div className='col-2 text-center'>Relato de incidente </div>):null}

                <div className='col-1  text-center'>{a.projeto}</div>
                <div className='col-1 text-center'>{a.dataCheckList}</div>
                <div className='col-1 text-center'>{a.numeroItem}</div>
                <div className='col-2 text-center'>{a.acao}</div>
                <div className='col-1 text-center'>{a.prazo}</div>
                <div className='col-1 text-center'>{a.dataExecucao}</div>
                <div className='col-1 text-center'>{a.usuario}</div>
                
        <div className='col-1 d-flex align-items-center justify-content-center'>
                    { a.dataExecucao !== null?
                    (
                        <div className='d-flex align-items-center'>              
                        <div style={{ width: '13px', height: '13px', backgroundColor: 'green', borderRadius: '50%', display: 'inline-block', marginLeft: '5px' }}></div>
                        <label className='ms-1' >Concluído</label>
                        </div> 
                  )  :
                  (
                   a.dataExecucao === null && moment(dataAtual).isSameOrAfter(moment(a.prazo, 'DD-MM-YYYY'), 'day')?
                  <div className='d-flex align-items-center'>              
                      <div style={{ width: '13px', height: '13px', backgroundColor: 'red', borderRadius: '50%', display: 'inline-block', marginLeft: '5px' }}></div>
                      <label className='ms-1'>Em atraso</label>
                      </div> 
                  : 
                  <div className='d-flex align-items-center'>              
                  <div style={{ width: '13px', height: '13px', backgroundColor: 'darkorange', borderRadius: '50%', display: 'inline-block', marginLeft: '5px' }}></div>
                  <label className='ms-1'>Aberto</label>
                  </div> 
                  )
                  }               
            </div>                  
                <div className='col-1 justify-content-center text-center'>
                { a.dataExecucao === null  ?(
                    <button data-bs-toggle="modal" data-bs-target={`#ModalAcoes-${a.id}`}  className="far fa-edit icone-acao green botaao"></button>
                )
                :
                (<button disabled  className="far fa-edit icone-acao green botaao"></button>)
                }
                </div>
                   <div class="modal" id={`ModalAcoes-${a.id}`} tabindex="" aria-labelledby="ModalAcoesLabel" aria-hidden="true" >
                        <div class="modal-dialog modal-dialog-centered modal-sm" >
                        <div class="modal-content">
                            <div class="modal-header">
                            <h1 class="modal-title fs-5" id="ModalAcoesLabel">Executar ação</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={()=>Limpar()}></button>
                            </div>
    
                            <div class="modal-body">
                            <div class="container text-center  ">
                        <div class="col  align-items-center justify-content-center p-2 ">
                            <div class="  align-items-center justify-content-center ">                        
                            <div className='d-flex mt-2 align-items-center'>
                                <div className='col-5'>
                                    <label>Data: </label>
                                </div>
                                <div className='col-7'>
                                    <input onChange={(e)=>setDataExecutada(e.target.value)} value={dataExecutada} className='form-control text-center borda ms-2' type='date'></input>
                                </div>                          
                            </div>

                            <div className='d-flex mt-2 align-items-center'>
                                    <div className='col-5'>
                                        <label>Responsável: </label> 
                                    </div>
                                    <div className='col-7'>
                                          <input disabled={true} className='form-control text-center borda ms-2' onChange={(e)=>setUsuario(e.target.value)} value={usuario}></input>   
                                    </div>
                             </div>
                            </div>
                            </div>
                        </div>
                            </div>
                            <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" onClick={()=>Limpar()} data-bs-dismiss="modal" >Fechar</button>             
                            <button type="button" class="btn btn-success" onClick={()=>SalvarAcoes(a.id) & Limpar()} data-bs-dismiss="modal" >Salvar</button>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                ):null}
             </div> ))  
             
             
             }   
    </div>
             )}




<br/><br/><br/>
        


    </body>
    )
};



